<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="font-weight-bold">Bezeichnung</label>
                    <input class="form-control" type="text" placeholder="Name" v-model="coupon.name">
                    <span class="form-text text-muted">Geben Sie einen Namen für den Gutscheincode an.</span>
                    <FormErrors :error="coupon.errors.name"/>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="font-weight-bold">Code</label>
                    <div class="input-group">
                        <input class="form-control" type="text" placeholder="XXX YYY ZZZ" v-model="coupon.code">
                        <div class="input-group-append">
                            <button class="btn btn-secondary btn-hover-primary" @click="generateCode">
                                <i class="fas fa-cog"/>
                                Generieren
                            </button>
                        </div>
                    </div>
                    <span class="form-text text-muted">Der Gutscheincode, der vom Kunden eingegeben werden muss.</span>
                    <FormErrors :error="coupon.errors.code"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="font-weight-bold">{{ __('general.type') }}</label>
                    <select class="form-control" v-model="coupon.type">
                        <option value="percent" :selected="coupon.type === 'percent'">
                            Prozentsatz
                        </option>
                        <option value="amount" :selected="coupon.type === 'amount'">
                            Betrag
                        </option>
                    </select>
                    <span class="form-text text-muted">Wählen Sie die Art des Nachlass an.</span>
                    <FormErrors :error="coupon.errors.type"/>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="font-weight-bold">{{ __('general.value') }}</label>
                    <div class="input-group">
                        <input class="form-control" type="number" v-model="coupon.value">
                        <div class="input-group-append">
                            <span v-if="coupon.type === 'percent'" class="input-group-text">%</span>
                            <span v-if="coupon.type === 'amount'" class="input-group-text">€</span>
                        </div>
                    </div>
                    <span class="form-text text-muted">Wählen Sie die Art des Nachlass an.</span>
                    <FormErrors :error="coupon.errors.value"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="font-weight-bold">Max Verwendungen</label>
                    <input class="form-control" type="number" placeholder="Unbegrenzt" v-model="coupon.max_redemptions">
                    <span class="form-text text-muted">Begrenzt die Anzahl der Verwendungen.</span>
                    <FormErrors :error="coupon.errors.max_redemptions"/>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="font-weight-bold">Gültig für (Monate)</label>
                    <input class="form-control" type="number" placeholder="Unbegrenzt"
                           v-model="coupon.months_discounted">
                    <span class="form-text text-muted">Die Anzahl der Monate welche reduziert sind.</span>
                    <FormErrors :error="coupon.errors.months_discounted"/>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="font-weight-bold">Ablaufdatum</label>
                    <input class="form-control" type="date" placeholder="Nie" v-model="coupon.expires_at">
                    <span class="form-text text-muted">Begrenzen Sie die Gültigkeitsdauer eines Gutscheincodes. Sie können Gutscheine jederzeit nachträglich invalidieren.</span>
                    <FormErrors :error="coupon.errors.expires_at"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormErrors from "../../Form/FormErrors.vue";

export default {
    components: {FormErrors},

    props: {
        value: Object
    },

    data() {
        return {
            coupon: {
                name: null,
                type: 'percent',
                value: null,
                code: null,
                months_discounted: null,
                max_redemptions: null,
                expires_at: null
            }
        }
    },

    beforeMount() {
        this.coupon = this.$inertia.form(this.value);
    },

    methods: {
        generateCode() {
            if (this.id !== undefined && this.coupon.code !== null) {
                if (!confirm('Do you really want to overwrite the code?' + this.id)) {
                    return;
                }
            }

            this.coupon.code = this.randomStringWithoutLookalikeCharacters(9).replace(/(.{3})/g, '$1 ');
        },

        randomStringWithoutLookalikeCharacters(length, characterPool = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789') {
            let out = '';

            for (let i = 0; i < length; i++) {
                out += characterPool.charAt(Math.floor(Math.random() * characterPool.length));
            }

            return out;
        }
    },

    watch: {
        coupon: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
